import { useNavigate } from "react-router-dom";

const BackIcon = () => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate("/instruction")}
      style={{ cursor: "pointer", filter: "brightness(0.6)" }}
    >
      <svg
        width="30"
        height="23"
        viewBox="0 0 30 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.487977 9.89621C0.175525 10.2088 -5.05191e-07 10.6326 -4.85873e-07 11.0745C-4.66556e-07 11.5165 0.175525 11.9403 0.487977 12.2529L9.91631 21.6812C10.0701 21.8404 10.254 21.9674 10.4573 22.0547C10.6606 22.1421 10.8793 22.188 11.1006 22.19C11.3219 22.1919 11.5414 22.1497 11.7462 22.0659C11.9511 21.9821 12.1371 21.8584 12.2936 21.7019C12.4501 21.5454 12.5739 21.3593 12.6577 21.1545C12.7415 20.9496 12.7836 20.7302 12.7817 20.5089C12.7798 20.2876 12.7338 20.0689 12.6465 19.8655C12.5591 19.6622 12.4322 19.4783 12.273 19.3246L5.68964 12.7412L27.7613 12.7412C28.2033 12.7412 28.6273 12.5656 28.9398 12.2531C29.2524 11.9405 29.428 11.5166 29.428 11.0745C29.428 10.6325 29.2524 10.2086 28.9398 9.89603C28.6273 9.58347 28.2033 9.40788 27.7613 9.40788L5.68964 9.40788L12.273 2.82453C12.5766 2.5102 12.7446 2.08919 12.7408 1.6522C12.737 1.21521 12.5617 0.797185 12.2527 0.488172C11.9437 0.179159 11.5256 0.00387523 11.0886 7.77166e-05C10.6516 -0.0037198 10.2306 0.164274 9.91631 0.46787L0.487977 9.89621Z"
          fill="#848484"
        />
      </svg>
    </div>
  );
};

export default BackIcon;
